import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getTypeColor } from "../../../constants/colors";

/**
 * 企業側のステータス表示コンポーネント
 *
 * - 表示専用
 * - 公開 / 非公開を示すだけ
 * - クリック・トグルなどの操作は一切行わない
 */
const RequestStatusCompany = ({ type }) => {
  // project / job に応じたテーマカラー
  const typeColor = getTypeColor(type);

  return (
    <Box
      sx={{
        bgcolor: "#f3f4f6",
        p: { xs: 1, sm: 3 },
        borderRadius: 2,
        mb: 3,
      }}
    >
      <Grid
        container
        alignItems="center"
        direction={{ xs: "column", sm: "row" }}
      >
        <Grid
          item
          xs={12}
          sm={4}
          sx={{
            textAlign: { xs: "center", sm: "left" },
            display: "flex",
            justifyContent: { xs: "center", sm: "flex-start" },
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            color="textSecondary"
            sx={{
              fontSize: { xs: "0.9rem", sm: "1.25rem" },
              pl: { xs: 0, sm: 2 },
            }}
          >
            ステータス
          </Typography>
        </Grid>
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: { xs: 0, sm: 2 },
            justifyContent: { xs: "center", sm: "flex-start" },
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "0.9rem", sm: "1.25rem" },
              fontWeight: "bold",
              mr: 1,
              lineHeight: 1,
              color: "#222",
            }}
          >
            希望条件：公開中
          </Typography>
          <CheckCircleIcon
            sx={{
              color: typeColor,
              fontSize: "1.4em",
              verticalAlign: "middle",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RequestStatusCompany;
